import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-478cd467"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import Spinner from '@/components/Spinner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    disabled: { type: Boolean },
    onClick: { type: Function },
    variant: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
    class: _normalizeClass(`${props.variant || 'primary'}-button`),
    disabled: props.disabled
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})